<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 问题交接 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <div>
            <el-select v-model="listQuery.game_id" filterable placeholder="游戏名称" style="margin-right: 15px">
              <el-option v-for="item in gameNameOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <el-input v-model="listQuery.from_admin_name" placeholder="发布人" style="width: 150px; margin-right: 15px"></el-input>
            <el-input v-model="listQuery.to_admin_name" placeholder="接管人" style="width: 150px; margin-right: 15px"></el-input>
            <el-input v-model="listQuery.content" placeholder="问题详情" style="width: 150px; margin-right: 15px"></el-input>
            <span>状态：</span>
            <el-select multiple collapse-tags v-model="listQuery.mission_status" filterable placeholder="状态" style="margin-right: 15px">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <el-select v-model="listQuery.msg_status" placeholder="是否已发送短信" style="margin-right: 15px">
              <el-option label="已发送" :value="1"></el-option>
              <el-option label="未发送" :value="0"></el-option>
            </el-select>
            <el-date-picker
              v-model="listQuery.created_at"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['24:00:00']"
              style="margin-top: 10px"
            ></el-date-picker>
            <span v-show="false">{{ updateMission }}</span>
          </div>

          <div style="float: right; margin: 30px 30px 20px 0">
            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            <el-button class="filter-item" type="success" @click="addQuestion">添加</el-button>
            <el-button class="filter-item" type="warning" @click.native="reset">重置</el-button>
          </div>
        </div>

        <el-table border v-loading="listLoading" :data="formData" style="width: 100%" min-height="200" max-height="1000">
          <el-table-column prop="created_at" label="发布时间" width="200" />
          <el-table-column prop="game_name" label="游戏名称" width="100" />
          <el-table-column prop="content" label="问题详情" width="300" :show-overflow-tooltip="true" />
          <el-table-column prop="from_admin_name" label="发布人" width="100" />
          <el-table-column prop="to_admin_name" label="接管人" width="100" />
          <el-table-column prop="status_text" label="状态" width="100" />
          <el-table-column prop="msg_status_text" label="短信发送状态" width="100" />
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="JoinTakeOver(scope.row)" v-if="scope.row.show_accept_button == true">加入接管</el-button>
              <el-button size="mini" type="danger" @click="cancelTakeOver(scope.row)" v-if="scope.row.show_cancel_button == true">取消接管</el-button>
              <el-button size="mini" type="warning" @click="notice(scope.row)" v-if="scope.row.show_inform_button == true">通知</el-button>
              <el-button size="mini" type="success" @click="handoverQuestion(scope.row)" v-if="scope.row.show_transfer_button == true">进行交接</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteQuestion(scope.row)" v-if="scope.row.show_delete_button == true">删除</el-button>
              <el-button size="mini" type="primary" @click="viewDetails(scope.row)">查看详情</el-button>
              <el-button size="mini" type="info" @click="finisheTask(scope.row)" v-if="scope.row.show_finish_button == true">结束</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog :title="popupTitle" width="40%" center :visible.sync="addQuestionShow" :close-on-click-modal="addControl" @close="closeDialog">
          <el-form style="margin-left: 40px">
            <el-form-item label="游戏名称" :label-width="formInputWidth">
              <el-col :span="8">
                <el-select v-model="add.game_id" filterable placeholder="请选择">
                  <el-option v-for="item in gameNameOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="用户账号" :label-width="formInputWidth">
              <el-col :span="8">
                <el-select
                  v-model="add.user_info"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="remoteMethod"
                >
                  <el-option
                    v-for="item in userOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="问题详情" :label-width="formInputWidth">
              <el-col :span="16">
                <el-input type="textarea" v-model="add.content" :rows="6"> </el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="图片" :label-width="formInputWidth">
              <el-col :span="16">
                <el-upload
                  v-model="add.images"
                  :action="apiUrl"
                  drag
                  multiple
                  list-type="picture-card"
                  :file-list="getStableImageFileList('add-images', files)"
                  :headers="file_headers"
                  :on-preview="handlePreview"
                  :on-success="addSuccess"
                  :on-remove="addRemove"
                  :on-change="(file, fileList) => trackImageUpload('add-images', file, fileList)"
                  :on-error="(error, file, fileList) => handleDirectUploadError('add-images', file, fileList)"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeAdd">取 消</el-button>
            <el-button type="primary" @click="sureAdd">确认</el-button>
          </div>
        </el-dialog>

        <div v-if="noticeShow == true">
          <el-dialog title="通知" center width="40%" :visible.sync="noticeShow">
            <el-form style="margin-left: 40px">
              <el-form-item label="接管人" :label-width="formInputWidth">
                <el-col :span="8">
                  <vipPublisher v-model="noticeReceiver"></vipPublisher>
                </el-col>
              </el-form-item>
              <el-form-item label="通知内容" :label-width="formInputWidth">
                <el-col :span="16">
                  <el-input type="textarea" v-model="noticeContent" :rows="6"> </el-input>
                </el-col>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="removeNotice">取 消</el-button>
              <el-button type="primary" @click="sureNotice">确认</el-button>
            </div>
          </el-dialog>
        </div>

        <el-dialog title="进行交接" width="60%" center :visible.sync="handoverShow">
          <el-form style="margin-left: 40px">
            <el-form-item label="游戏名称" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input v-model="handover.game_name" :disabled="handoverDisabled"> </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="发布人" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input v-model="handover.from_admin_name" :disabled="handoverDisabled"> </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="创建时间" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input v-model="handover.created_at" :disabled="handoverDisabled"> </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="历史接管人" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input v-model="handover.to_admin_name" :disabled="handoverDisabled"> </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="问题详情" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input type="textarea" v-model="handover.content" :rows="6"> </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="图片" :label-width="formInputWidth">
              <el-col :span="16">
                <el-upload
                  v-model="handover.images"
                  :action="apiUrl"
                  drag
                  multiple
                  list-type="picture-card"
                  :file-list="getStableImageFileList('handover-images', handover.files)"
                  :headers="file_headers"
                  :on-preview="handlePreview"
                  :on-success="handoverSuccess"
                  :on-remove="handoverRemove"
                  :on-change="(file, fileList) => trackImageUpload('handover-images', file, fileList)"
                  :on-error="(error, file, fileList) => handleDirectUploadError('handover-images', file, fileList)"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-col>
            </el-form-item>
            <el-form-item label="接管人" :label-width="formInputWidth" v-if="handoverShow == true">
              <el-col :span="8">
                <vipPublisher v-model="handover.to_admin_ids"></vipPublisher>
              </el-col>
            </el-form-item>
            <el-form-item label="钉钉通知内容" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input type="textarea" v-model="handover.ding_content" :rows="6"> </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="是否进行通知" :label-width="formInputWidth">
              <el-col :span="8">
                <el-radio v-model="handover.is_send_notice" label="1">是</el-radio>
                <el-radio v-model="handover.is_send_notice" label="2">否</el-radio>
              </el-col>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button @click="removeHandover">取 消</el-button>
            <el-button type="primary" @click="sureHandover">确认</el-button>
          </div>
        </el-dialog>

        <el-dialog title="删除" width="40%" center :visible.sync="deleteShow">
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeDelete">取 消</el-button>
            <el-button type="primary" @click="sureDelete">确认</el-button>
          </div>
        </el-dialog>

        <el-dialog title="结束" width="40%" center :visible.sync="endShow">
          <el-form style="margin-left: 20px">
            <el-form-item label="备注" :label-width="formInputWidth">
              <el-col :span="16">
                <el-input resize="none" type="textarea" v-model="end.remarks" :show-word-limit="true" :rows="6"> </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="图片" :label-width="formInputWidth">
              <el-col :span="24">
                <ImageUpload :imgList="end.images" :multiple="true" @upload-state-change="endUploadState = $event"></ImageUpload>
              </el-col>
            </el-form-item>
            <!-- 新增的发送短信的手机号 -->
            <el-form-item label="短信通知" :label-width="formInputWidth">
              <el-col :span="16">
                <el-input type="text" placeholder="请输入手机号" v-model="end.mobile" :rows="6"> </el-input>
              </el-col>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button @click="removeEnd">取 消</el-button>
            <el-button type="primary" @click="sureEnd">确认</el-button>
          </div>
        </el-dialog>

        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="questionHandover" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/index';
import ImageUpload from '@/components/common/ImageUpload/ImageUpload.vue';
import vipPublisher from '@/components/common/vipPublisher';
import {
  getMissionSelectApi,
  questionHandoverApi,
  questionAddApi,
  acceptMissionApi,
  cancelMissionApi,
  deleteApi,
  finishTaskApi,
  getHandoverApi,
  putHandoverApi,
  publishTaskApi,
  getAdminUserListApi
} from '@/api/problem.js';
import { personalCenterApi } from '@/api/personalCenter.js';
import BASE_API from '@/config';
import { getToken } from '@/utils/localStorage.js';
import { appendImageInSelectionOrder, imageUploadMixin, normalizeImageList, removeImageByUploadFile } from '@/utils/imageUpload.js';
export default {
  mixins: [imageUploadMixin],
  components: { Pagination, vipPublisher, ImageUpload },
  name: 'problem',
  data() {
    return {
      listQuery: {
        game_id: '',
        from_admin_name: '',
        mission_status: [],
        created_at: '',
        msg_status: '',
        content: '',
        limit: 10,
        page: 1,
      },
      formData: [],
      gameNameOptions: [],
      userOptions: [],
      statusOptions: [],
      add: {
        game_id: '',
        content: '',
        images: [],
      },
      noticeReceiver: [],
      noticeContent: '',

      // 添加数据的缓存。
      addData: {},
      addCheck: 0,

      // 接管信息
      handover: {
        id: '',
        game_name: '',
        from_admin_name: '',
        to_admin_name: '',
        created_at: '',
        content: '',
        is_send_notice: '',
        ding_content: '',
        images: [],
        files: [],
        to_admin_ids: [],
      },
      end: {
        id: '',
        remarks: '',
        images: [],
        files: [],
        mobile: '', // 结束时候输入的手机号
      },
      endUploadState: { canSubmit: true },
      noticeTaskId: '',
      deleteID: '',
      popupTitle: '',

      total: 0,
      listLoading: false,
      addQuestionShow: false,
      noticeShow: false,
      handoverShow: false,
      deleteShow: false,
      endShow: false,
      handoverDisabled: true,
      filterable: true,
      formInputWidth: '200px',

      // 添加功能，上传图片
      files: [],
      file_headers: {
        //头带当前用户信息
        Authorization: 'Bearer ' + getToken(),
      },
      apiUrl: BASE_API + 'admin/work_upload_admin',

      // 实时更新的数据信息
      updataData: 0,
    };
  },
  computed: {
    updateMission() {
      let data = this.$store.state.websockData;
      for (let item of data) {
        if (item.type == 'refresh_mission') {
          let data = this.updateCheck();
          if (data == false) {
            this.updataData = this.updataData + 1;
            this.questionHandover();
          }
        }
      }
      return this.updataData;
    },
    addControl() {
      let item = true;
      if (this.popupTitle == '添加') {
        item = false;
      }
      return item;
    },
  },
  created() {
    this.questionHandover();
    this.getMissionSelect();
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        getAdminUserListApi({ account: query })
          .then((response) => {
            this.userOptions = response.data.data.map((item) => {
              return {
                value: `${query}(${item.user_id})/${item.app_name}(${item.app_key})/${item.role_name}(${item.role_id})/${item.server_id}`,
                label: `${item.app_name}(${item.app_key})/${item.role_name}(${item.role_id})/${item.server_id}/${item.user_id}`,
              };
            });
            if (this.userOptions.length == 0) {
              this.userOptions = [
                {
                  value: query,
                  label: query,
                }
              ];
            }
          })
          .catch((error) => {
            this.userOptions = [];
          });
      } else {
        this.userOptions = [];
      }
    },
    questionHandover() {
      this.listLoading = true;
      questionHandoverApi(this.listQuery)
        .then((response) => {
          this.formData = response.data.data.data;
          this.total = response.data.data.total;
          this.listLoading = false;
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
    getMissionSelect() {
      getMissionSelectApi()
        .then((response) => {
          this.gameNameOptions = response.data.data.game;
          this.statusOptions = response.data.data.status;
        })
        .catch((error) => {});
    },
    addQuestion() {
      this.resetImageUploadScope('add-images');
      this.popupTitle = '添加';
      this.add.game_id = '';
      this.add.content = '';
      this.add.images = [];
      this.files = [];
      if (this.addCheck == 1) {
        this.add = JSON.parse(JSON.stringify(this.addData));
        this.files = this.add.images;
      }
      this.addQuestionShow = true;
    },
    removeAdd() {
      this.addQuestionShow = false;
    },
    sureAdd() {
      if (!this.guardImageUploads(['add-images'])) return;
      questionAddApi(this.add)
        .then((response) => {
          if (response.data.code == 200) {
            this.$message.success(response.data.message);
            this.addCheck = 2;
            this.addQuestionShow = false;
            this.questionHandover();
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
    },
    closeDialog() {
      if (this.addCheck == 0 || this.addCheck == 1) {
        this.addData = JSON.parse(JSON.stringify(this.add));
        this.addCheck = 1;
      }
      if (this.addCheck == 2) {
        this.addCheck = 0;
        this.addData = {};
      }
    },
    search() {
      this.listQuery.page = 1;
      this.questionHandover();
    },
    reset() {
      this.listQuery.game_id = '';
      this.listQuery.from_admin_name = '';
      this.listQuery.mission_status = [];
      this.listQuery.created_at = '';
      this.listQuery.content = '';
      this.listQuery.page = 1;
      this.questionHandover();
    },
    JoinTakeOver(item) {
      let data = {
        id: '',
      };
      data.id = item.id;
      acceptMissionApi(data)
        .then((response) => {
          this.$message.success(response.data.message);
          this.questionHandover();
        })
        .catch((error) => {});
    },
    cancelTakeOver(item) {
      let data = {
        id: '',
      };
      data.id = item.id;
      cancelMissionApi(data)
        .then((response) => {
          this.$message.success(response.data.message);
          this.questionHandover();
        })
        .catch((error) => {});
    },
    notice(item) {
      this.noticeTaskId = item.id;
      this.noticeReceiver = [];
      this.noticeContent = '';
      this.noticeShow = true;
    },
    removeNotice() {
      this.noticeShow = false;
    },
    sureNotice() {
      if (this.noticeReceiver.length == '') {
        this.$message.error('请先选择被通知人');
        return;
      }
      let data = {
        id: '',
        to_admin_ids: [],
        ding_content: '',
      };
      for (let item of this.noticeReceiver) {
        data.to_admin_ids.push(item[item.length - 1]);
      }
      data.id = this.noticeTaskId;
      data.ding_content = this.noticeContent;
      publishTaskApi(data)
        .then((response) => {
          if (response.data.code == 200) {
            this.noticeShow = false;
            this.questionHandover();
            this.$message.success(response.data.message);
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {
          {
          }
        });
    },
    handoverQuestion(item) {
      this.resetImageUploadScope('handover-images');
      this.handover.content = '';
      this.handover.is_send_notice = '';
      this.handover.ding_content = '';
      this.handover.images = [];
      this.handover.files = [];
      this.handover.to_admin_ids = [];
      let data = {
        id: '',
      };
      data.id = item.id;
      getHandoverApi(data)
        .then((response) => {
          this.handover.id = response.data.data.id;
          this.handover.game_name = response.data.data.game_name;
          this.handover.from_admin_name = response.data.data.from_admin_name;
          this.handover.to_admin_name = response.data.data.to_admin_name;
          this.handover.created_at = response.data.data.created_at;
          this.handover.content = response.data.data.content;
          this.handover.is_send_notice = response.data.data.is_send_notice;
          this.handover.images = normalizeImageList(response.data.data.images, 'handover');
          this.handover.files = this.handover.images;
        })
        .catch((error) => {});
      this.handoverShow = true;
    },
    removeHandover() {
      this.handoverShow = false;
    },
    sureHandover() {
      if (!this.guardImageUploads(['handover-images'])) return;
      let data = {
        images: [],
        content: '',
        id: '',
        to_admin_ids: [],
        is_send_notice: '',
        ding_content: '',
      };
      for (let item of this.handover.to_admin_ids) {
        if (item[2] != '') {
          data.to_admin_ids.push(item[2]);
        } else if (item[3] != '') {
          data.to_admin_ids.push(item[3]);
        }
      }

      data.id = this.handover.id;
      data.content = this.handover.content;
      data.images = this.handover.images;
      data.is_send_notice = this.handover.is_send_notice;
      data.ding_content = this.handover.ding_content;
      putHandoverApi(data)
        .then((response) => {
          if (response.data.code == 200) {
            this.handoverShow = false;
            this.questionHandover();
            this.$message.success(response.data.message);
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
    },

    deleteQuestion(item) {
      this.deleteID = item.id;
      this.deleteShow = true;
    },
    removeDelete() {
      this.deleteShow = false;
    },
    sureDelete() {
      deleteApi({ id: this.deleteID })
        .then((response) => {
          if (response.data.code == 200) {
            this.deleteShow = false;
            this.personalCenter();
            this.$message.success(response.data.message);
            this.questionHandover();
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
    },
    personalCenter() {
      personalCenterApi()
        .then((response) => {
          let data = response.data.data;
          if (data.notice_level_3 != 0) {
            data.number = data.number - data.notice_level_3;
          }
          this.$store.commit('getNotice', data);
        })
        .catch((error) => {});
    },
    viewDetails(item) {
      // let data ={
      //           id:""
      //       }
      let id = item.id;
      // data = JSON.stringify(data)
      this.$router.push({ path: '/customer-problem_content_view', query: { id } });
    },
    finisheTask(item) {
      this.end.id = item.id;
      this.end.remarks = '';
      this.end.mobile = '';
      this.end.images = [];
      this.end.files = [];
      this.endUploadState = { canSubmit: true };
      this.endShow = true;
    },
    // 取消结束
    removeEnd() {
      this.endShow = false;
    },
    // 确定结束
    sureEnd() {
      if (!this.endUploadState.canSubmit) {
        this.$message.warning(this.endUploadState.failedCount ? '有图片上传失败，请移除后重新选择' : '图片正在上传，请稍后');
        return;
      }
      let data = {
        id: '',
        content: '',
        images: '',
      };
      data.id = this.end.id;
      data.content = this.end.remarks;
      data.images = this.end.images;
      if (this.end.mobile !== '') {
        data.mobile = this.end.mobile;
      }
      finishTaskApi(data)
        .then((response) => {
          if (response.data.code == '200') {
            this.$message.success(response.data.message);
            this.questionHandover();
          } else {
            this.$message.error(response.data.message);
          }
          this.endShow = false;
        })
        .catch((error) => {});
    },

    // 图片放大
    handlePreview(file) {
      // console.log(file)
      window.open(file.url, '_blank');
    },

    //  添加任务  插入图片功能
    addSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('add-images', file)) return;
      if (response.code != 200) {
        file.status = 'fail';
        this.trackImageUpload('add-images', file, fileList);
        this.$message.error(response.message);
      } else {
        this.files = appendImageInSelectionOrder(this.files, file, { url: response.data.path, name: response.data.name || file.name });
        this.add.images = this.files;
        this.trackImageUpload('add-images', file, fileList);
        this.$message.success(response.message);
      }
    },
    addRemove(file, fileList) {
      this.files = removeImageByUploadFile(this.files, file);
      this.add.images = this.files;
      this.removeTrackedImage('add-images', file, fileList);
    },

    // 结束任务  插入图片功能
    endSuccess(response, file) {
      console.log(response);
      if (response.code != 200) {
        this.$message.error(response.message);
      } else {
        this.end.files.push({ url: response.data.path });
        this.end.images = this.end.files;
        this.$message.success(response.message);
      }
    },
    endRemove(file) {
      const result = [];
      this.end.files.forEach((element) => {
        if (file.uid != element.uid) {
          result.push(element);
        }
      });
      this.end.files = result;
      this.end.images = this.end.files;
    },

    // 进行交接  插入图片功能
    handoverSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('handover-images', file)) return;
      if (response.code != 200) {
        file.status = 'fail';
        this.trackImageUpload('handover-images', file, fileList);
        this.$message.error(response.message);
      } else {
        this.handover.files = appendImageInSelectionOrder(this.handover.files, file, { url: response.data.path, name: response.data.name || file.name });
        this.handover.images = this.handover.files;
        this.trackImageUpload('handover-images', file, fileList);
        this.$message.success(response.message);
      }
    },
    handoverRemove(file, fileList) {
      this.handover.files = removeImageByUploadFile(this.handover.files, file);
      this.handover.images = this.handover.files;
      this.removeTrackedImage('handover-images', file, fileList);
    },
    handleDirectUploadError(scope, file, fileList) {
      if (!this.isCurrentImageUpload(scope, file)) return;
      this.trackImageUpload(scope, file, fileList);
      this.$message.error(`${file.name || '图片'}上传失败`);
    },
    updateCheck() {
      let check = false;
      if (this.listQuery.game_id != '') {
        check = true;
      }
      if (this.listQuery.from_admin_name != '') {
        check = true;
      }
      if (this.listQuery.mission_status.length > 0) {
        check = true;
      }
      if (this.listQuery.created_at != '') {
        check = true;
      }
      if (this.listQuery.content != '') {
        check = true;
      }
      if (this.addQuestionShow == true) {
        check = true;
      }
      if (this.noticeShow == true) {
        check = true;
      }
      if (this.handoverShow == true) {
        check = true;
      }
      if (this.deleteShow == true) {
        check = true;
      }
      if (this.endShow == true) {
        check = true;
      }
      return check;
    },
  },
};
</script>


<style scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #f3f3f3;
  box-sizing: border-box;
}
.error-code {
  line-height: 1;
  font-size: 250px;
  font-weight: bolder;
  color: #f02d2d;
}
.error-code span {
  color: #00a854;
}
.error-desc {
  font-size: 30px;
  color: #777;
}
.error-handle {
  margin-top: 30px;
  padding-bottom: 200px;
}
.error-btn {
  margin-left: 100px;
}
</style>
